// src/App.js
import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <main className="construction-main">
        <div className="construction-content">
          <div className="logo-container">
            <div className="logo">🚀</div>
          </div>
          <h1>Something exciting is on the way!</h1>
          <p>This site is under construction, but soon you'll find projects, blog posts, and plenty more. Stay tuned!</p>
          
          <div className="social-links">
            <a href="mailto:ganzamick@gmail.com" className="social-link">📧 Email</a>
            <a href="https://github.com/RuTpasswd" className="social-link">💻 GitHub</a>
            <a href="https://www.linkedin.com/in/mick-ganza/" className="social-link">💼 LinkedIn</a>
          </div>
          
          <div className="countdown">
            <p>Launching soon...</p>
          </div>
        </div>
      </main>
    </div>
  );
}

export default App;